import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class TestService {

    constructor(private http: HttpServices, private _http: HttpClient) { }

    getAllPagedSorted(pageIndex, pageSize, sortKey, sortDirection) {
        return this.http.get('Test/GetAllPagedSorted' + '/' + pageIndex + '/' + pageSize + '/' + sortKey + '/' + sortDirection);
    }
}